import { useMemo } from "react";
import { models } from "jiffy-api";
import { useImagesFastCache, type CachedImage } from "./useImagesFastCache";

type ArtworkEnhancedImagesResult = {
  print_original: CachedImage | undefined;
  custom: CachedImage | undefined;
  full_enhancements: CachedImage | undefined;
};

/* eslint-disable max-params */
export function useArtworkEnhancedImages(
  artwork: models.cable.DtfChannel.fetchDeliveryDate.Artwork | undefined,
  removeBackground: boolean,
  canRemoveBackground: boolean = true,
  editImageManual: boolean = false
): ArtworkEnhancedImagesResult {
  const [noBgUrl] = useImagesFastCache(artwork && [artwork.noBgUrl || artwork.noBgNoTrimUrl]);

  const [originalImage, withBgUrl] = useImagesFastCache(
    artwork ? [artwork.originalImageUrl, artwork.withBgUrl] : []
  );

  const [manualEditImage] = useImagesFastCache(
    artwork?.manualEditUrl ? [artwork.manualEditUrl] : []
  );

  return useMemo(() => {
    const result: ArtworkEnhancedImagesResult = {
      print_original: undefined,
      custom: undefined,
      full_enhancements: undefined
    };

    if (originalImage?.base64) {
      result.print_original = originalImage;

      result.custom = originalImage;
    }

    if (editImageManual && manualEditImage?.base64) {
      result.full_enhancements = manualEditImage;
    } else if (removeBackground && canRemoveBackground && noBgUrl) {
      result.full_enhancements = noBgUrl;
    } else if (withBgUrl) {
      result.full_enhancements = withBgUrl;
    }

    return result;
  }, [
    noBgUrl,
    originalImage,
    removeBackground,
    withBgUrl,
    canRemoveBackground,
    editImageManual,
    manualEditImage
  ]);
}
/* eslint-enable max-params */
